class productDoubleColumn extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
    }
    connectedCallback(){
      this.title = this.dataset.title || '';
      this.fit = this.dataset.fit || '';
      window.postProductData(`${this.dataset.url}.js`).then(res=>{
        this.media = res.data.media;
        this.variants = res.data.variants
        this.observeEvent();
        this.getProductImgGrid();
        this.querySelector('.show-more').onclick = ()=>{
          this.dataset.more = 'true'
          this.flag = true
        }
      })
    }
    reduceData(media){
        let data =  media.reduce((total, currentValue) => {
              return {
                  ...total,
                  ...Object.keys(currentValue).reduce((_r, _c) => { 
                      if(_c == 'featured_media'){
                        let color = currentValue['option3'] == "Regular" || currentValue['option3'] == "Tall" || !currentValue['option3'] ? currentValue['option1'] : currentValue['option2'];
                        let optionFit = currentValue['options'].find(item => item.indexOf('Fit') > -1);
                        let fit = optionFit && this.dataset.fit ? optionFit : (!optionFit && this.dataset.fit ? this.dataset.fit : currentValue['option1'])
                          if (total[fit]) {
                              total[fit].push({
                                  position : currentValue['featured_media'].position,
                                  color,
                                  imageId:currentValue.featured_media.id,
                                  imgSrc:currentValue.featured_image.src,
                                  fit
                              })
                          }
                          else {
                              total[fit] = [{
                                  position : currentValue['featured_media'].position,
                                  color,
                                  imageId:currentValue.featured_media.id,
                                  imgSrc:currentValue.featured_image.src,
                                  fit
                              }]
                          }
                      }
                      return total
                  }, {})
              }
        }, {});
        return data;
    }
    changeArr(target,type){
      if(type == 'img'){
        let newArr = target.sort((a,b)=>{return a.position - b.position}); 
        let arr = [];
        newArr.forEach((item,index,array)=>{
            let arrIndex = index + 1 >= array.length ? array.length - 1 : index + 1 ;
            if(array[arrIndex].position != item.position){
                arr.push(item)
            }
            else if(index ==  array.length - 1){
                arr.push(item)
            }
        })
        this.newArr = arr;
        return arr;
      }
      else{
        let arr = {};
        for(let key in target){
          arr[key] = []
          let newArr = target[key].sort((a,b)=>{return a.position - b.position}); 
          newArr.forEach((item,index,array)=>{
              let arrIndex = index + 1 >= array.length ? array.length - 1 : index + 1 ;
              if(array[arrIndex].position != item.position){
                  arr[key].push(item)
              }
              else if(index ==  array.length - 1){
                  arr[key].push(item)
              }
          })
        }
        return arr;
      }
    }
    changeImage(res){
      if(!res) return;
      let data = res.reduce((total, currentValue) => {
              return {
                  ...total,
                  ...Object.keys(currentValue).reduce((_r, _c) => { 
                      if(_c == 'src'){
                          if (total[_c]) {
                              total[_c].push({
                                  src:currentValue.src,
                                  imageId:currentValue.id,
                                  position:currentValue.position,
                              })
                          }
                          else {
                              total[_c] = [{
                                  src:currentValue.src,
                                  imageId:currentValue.id,
                                  position:currentValue.position,
                              }]
                          }
                      }
                      else if(_c == 'sources'){
                        if (total['src']) {
                              total['src'].push({
                                  src:currentValue.preview_image.src,
                                  imageId:currentValue.id,
                                  position:currentValue.position,
                                  sources:currentValue.sources[2] ? currentValue.sources[2].url : currentValue.sources[1].url,
                              })
                          }
                          else {
                              total['src'] = [{
                                  src:currentValue.preview_image.src,
                                  imageId:currentValue.id,
                                  position:currentValue.position,
                                  sources:currentValue.sources[2] ? currentValue.sources[2].url : currentValue.sources[1].url,
                              }]
                          }
                      }
                      return total
                  }, {})
              }
        }, {});
      return data;
    }
    getSecondProperty(obj) {
      const keys = Object.keys(obj);
      if (keys.length < 2) return undefined;
      return obj[keys[1]];
    }
    getProductImgGrid(){
      new Promise((resolve, reject)=>{
          this.baseImgArray = this.media;
          if(this.baseImgArray.length == 1){
            let temp = `
                <div class="swiper-slide" >
                  <img src="${this.baseImgArray[0].src}" class="swiper-lazy hs-lazyload lazyload" loading="lazy" is="lazy-image"/>
                </div>
            `
            this.querySelector('.swiper-wrapper').innerHTML = temp
          }
          else{
            resolve();
          }
          
       }).then(()=>{
         setTimeout(()=>{
           let featured_media  = this.reduceData(this.variants);
           let arr = this.changeArr(featured_media);
           this.swiperSlideObject = {};
           let { src } = this.changeImage(this.baseImgArray);
           let imageArray = this.changeArr(src,'img');
           for(let key in featured_media){
            this.swiperSlideObject[key] = {}
            let initArray = featured_media[key]
            let array = arr[key]
            let num = array[0].position -1
            let length = num == 0 && Object.keys(featured_media).length > 1 ? this.getSecondProperty(featured_media) && this.getSecondProperty(featured_media)[0].position : initArray.length + num;
            // let length = initArray.length + num;
            if(imageArray.length > length && Object.keys(featured_media).length == 1) length = imageArray.length
            let temp = 1,limit = 0,totalSlide = '';
            for(let i = num;i<length;i++){
              let position = imageArray && imageArray[i] && imageArray[i].position;
              if(array[temp] && position >= array[temp].position ){
                this.swiperSlideObject[key][array[temp - 1].color]= totalSlide;
                totalSlide = '';
                temp += 1;
              }
              if(imageArray[i]){
                imageArray[i].sources ?
                  totalSlide+= `<div class="swiper-slide" data-position="${i}">
                    <deferred-media class="deferred-media media media-- no-js-hidden" data-media-id="${imageArray[i].imageId}">
                      <img src="${imageArray[i].src}" class="swiper-lazy hs-lazyload lazyload" loading="lazy" is="lazy-image" widths="165, 360, 535, 750, 940, 1100" alt="${this.dataset.title||''} ${this.dataset.color||''}"
                      srcset="${imageArray[i].src}&width=360 360w,${imageArray[i].src}&width=535 535w,${imageArray[i].src}&width=750 750w,${imageArray[i].src}&width=940 940w,${imageArray[i].src}&width=1100 1100w"/>
                      <template>
                        <video autoplay loop playsinline preload="auto" muted x5-video-player-fullscreen="true" src="${imageArray[i].sources}" alt="" poster="${imageArray[i].src}" width="100%">Your browser cannot play this video.</video>
                        
                      </template>
                      <button id="Deferred-Poster-${imageArray[i].imageId}" class="deferred-media__poster" type="button">
                            <span class="deferred-media__poster-button motion-reduce">
                              <span class="visually-hidden">Play video</span>
                              <svg t="1766125565226" class="icon" viewBox="0 0 1085 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18159" xmlns:xlink="http://www.w3.org/1999/xlink" width="211.9140625" height="200">
                                <path d="M546.904228 18.10573c-277.76918 0-502.94529 225.17611-502.94529 502.94529 0 277.77164 225.17488 502.94775 502.94529 502.94775 277.76795 0 502.94529-225.17611 502.94529-502.94775C1049.849518 243.28307 824.672178 18.10573 546.904228 18.10573L546.904228 18.10573zM546.904228 973.701659c-249.992631 0-452.651868-202.659237-452.651868-452.651868 0-249.990172 202.659237-452.649408 452.651868-452.649408s452.650638 202.659237 452.650638 452.649408C999.554866 771.042422 796.896859 973.701659 546.904228 973.701659L546.904228 973.701659zM775.203924 485.406478c-78.267962-53.25591-220.1919-132.967608-301.004232-182.358388-33.132146-20.893592-60.993549-12.502952-63.667043 24.399633-1.938099 98.840588 0 289.550264 0 390.101445 1.681079 37.462125 34.709926 42.403293 63.37559 27.362121 80.72133-48.906255 219.456505-132.95777 300.588574-182.112436C773.968017 562.476656 836.097862 528.305364 775.203924 485.406478L775.203924 485.406478z" fill="#ffffff" p-id="18160"></path>
                              </svg>
                            </span>
                          </button>
                      </deferred-media>
                    </div>` 
                :
                  totalSlide+= `
                  <div class="swiper-slide" data-position="${i}">
                    <use-animate data-animate="zoom-fade" class="product-slider-mobile" animate="" >
                      <div class="image-animate media--adapt">
                        <img src="${imageArray[i].src}" class="swiper-lazy hs-lazyload lazyload" loading="lazy" is="lazy-image" widths="165, 360, 535, 750, 940, 1100" alt="${this.dataset.title||''} ${this.dataset.color||''}"
                        srcset="${imageArray[i].src}&width=360 360w,${imageArray[i].src}&width=535 535w,${imageArray[i].src}&width=750 750w,${imageArray[i].src}&width=940 940w,${imageArray[i].src}&width=1100 1100w"/>
                        <div class="hand-box"></div>
                      </div>
                    </use-animate> 
                  </div>` ;
              } 
            }
              // 3. 🌟 关键优化：循环结束后，把篮子里最后剩下的 HTML 存给最后一个颜色
            if(totalSlide && array[temp - 1]) {
              this.swiperSlideObject[key][array[temp - 1].color] = totalSlide;
            }
           }
          //  this.swiperSlideObject = swiperSlideObject;
           // document.querySelector('product-thumb .swiper-wrapper').innerHTML = swiperSlideObject[this.getAttribute('data-color')]
           if(this.swiperSlideObject[this.dataset.fit]){
              document.querySelector('product-thumb .swiper-wrapper').innerHTML = this.swiperSlideObject[this.dataset.fit][this.getAttribute('data-color')]||'';
              this.querySelector('.swiper-wrapper').innerHTML = this.swiperSlideObject[this.dataset.fit][this.getAttribute('data-color')]||'';
           }
           else{
            document.querySelector('product-thumb .swiper-wrapper').innerHTML = this.swiperSlideObject[this.getAttribute('data-color')][this.getAttribute('data-color')]||'';
           this.querySelector('.swiper-wrapper').innerHTML = this.swiperSlideObject[this.getAttribute('data-color')][this.getAttribute('data-color')]||'';
           }
           
            this.productDoubleColumnSwiper();
           // this.onclick = (event)=>{
           //    if(event.target.closest('.swiper-button-next') || event.target.closest('.swiper-button-prev'))return;
           //    const clickedSlide = event.target.closest('.icon-close');
           //    if (clickedSlide) {
           //      this.productSwiper.params.slidesPerView === 1 ? this.querySelector('.icon-close').classList.add('hidden') : this.querySelector('.icon-close').classList.remove('hidden')
           //      this.productSwiper.update();
           //    }
           // }
         },500)
       }).then(()=>{
        })
    }
    setStyles(dom, rules){
      for (let key in rules ){
              dom.style[key] = rules[key];
      }
    }
    onMouserProductImg(target){
      let handBoxSize = {width: 0, height: 0}
      let handBox = target.querySelector('.hand-box');
      let bWidth = this.viewSize.width * 2;
      let bHeight = this.viewSize.height * 2;
      handBoxSize.width = (this.viewSize.width/bWidth)* this.viewSize.width
      handBoxSize.height = (this.viewSize.height/bHeight)*this.viewSize.height
      this.setStyles(handBox, {
        width: handBoxSize.width + 'px',
        height: handBoxSize.height + 'px'
      });
      let xScale = bWidth / handBoxSize.width;
      let yScale = bHeight / handBoxSize.height;
      let maxX = this.viewSize.width - handBoxSize.width;
      let maxY = this.viewSize.height - handBoxSize.height;
      let bgWidth = target.querySelector('img').clientWidth * xScale;
      let bgHeight = target.querySelector('img').clientHeight * yScale;
      this.bindEvent(handBoxSize,this.viewSize,maxX,maxY,bWidth,bHeight,bgWidth,bgHeight,target)
    }
    bindEvent(handBoxSize,viewSize,maxX,maxY,bWidth,bHeight,bgWidth,bgHeight,target){
      let handBox = target.querySelector('.hand-box')
      let maxWidth = 0;
      let bimgBox = target.querySelector('img')
      const on = (dom, type, fn)=>{
          if (dom.addEventListener){
              dom.addEventListener(type, fn, false);
          }
          else if (dom.attachEvent){
              dom.attachEvent('on' + type, fn);
          }
      }
      const move = (event) =>{
        setAreaPosition(event)
        event && event.stopImmediatePropagation();
      }
      const enter = (event) => {
        // bimgBox.style.visibility = 'visible';
        bimgBox.style.transform = 'scale(2)';
        let x = event.offsetX - handBoxSize.width / 2;
        let y = event.offsetY - handBoxSize.height / 2
        x = Math.min(Math.max(0,x),maxX);
        y = Math.min(Math.max(0,y),maxY);
        handBox.style.transform = `translate3d(${x }px,${y}px,0)`;
        bimgBox.style.transformOrigin = `${(x * bWidth / this.viewSize.width )}px ${(y * bHeight / this.viewSize.height)}px`;
        on(target,'mousemove',move)
        on(target,'mouseleave',leave)
        event && event.stopImmediatePropagation();
      }
      const leave = () => {
        // bimgBox.style.visibility = 'hidden'
        bimgBox.style.transform = 'scale(1)';
        target.removeEventListener("mousemove",move);
        target.removeEventListener("mouseleave",leave);
        event && event.stopImmediatePropagation();
      }
      const enterImgScale = (event)=>{
        let x = event.offsetX - handBoxSize.width / 2;
        let y = event.offsetY - handBoxSize.height / 2
        x = Math.min(Math.max(0,x),maxX);
        y = Math.min(Math.max(0,y),maxY);
        handBox.style.transform = `translate3d(${x}px,${y}px,0)`;
        bimgBox.style.transformOrigin = `${(x * bWidth / this.viewSize.width )}px ${(y * bHeight / this.viewSize.height)}px`;
        event && event.stopImmediatePropagation();
      }
      const setAreaPosition = (event)=>{
        // if(event.target.classList.contains('img-scale-wrapper')) return;
        let top = handBox.getBoundingClientRect().top - target.getBoundingClientRect().top
        let left = handBox.getBoundingClientRect().left - target.getBoundingClientRect().left;
        let x = parseFloat(left) + parseFloat(event.offsetX) - handBoxSize.width / 2;
        let y = parseFloat(top) + parseFloat(event.offsetY) - handBoxSize.height / 2;
        x = Math.min(Math.max(0,x),maxX);
        y = Math.min(Math.max(0,y),maxY);
        handBox.style.transform = `translate3d(${x}px,${y}px,0)`;
        // handBox.style.background = "#fff"
        // bimgBox.style.backgroundPosition = `${-(x * bWidth / this.viewSize.width )}px ${-(y * bHeight / this.viewSize.height)}px`;
        bimgBox.style.transformOrigin = `${(x * bWidth / this.viewSize.width )}px ${(y * bHeight / this.viewSize.height)}px`;
      }
      // on(target,"mouseenter",enter)
      on(handBox,"mouseenter",enter)
      on(bimgBox,"mouseenter",enter)
    }
    onChangeProductThumbSwiper(){
      document.querySelectorAll('product-thumb .swiper-slide').forEach((item,index) =>{
        if(index == 0) item.classList.add('swiper-slide-thumb-active')
        item.onclick =()=>{
          if(this.productSwiper.realIndex == index) return;
          this.productSwiper.slideTo(index,0,false)
          setTimeout(()=>{
            item.classList.add('swiper-slide-thumb-active')
            let previousIndex = this.productSwiper.previousIndex
            let preSlide = document.querySelectorAll('product-thumb .swiper-slide')[previousIndex]
            if(preSlide && preSlide.classList.contains('swiper-slide-thumb-active')) preSlide.classList.remove('swiper-slide-thumb-active')
          },500)
        }
      })
    }
    productThumbSwiper(){
      let direction = 'horizontal'
      this.thumbSwiper = new Swiper('product-thumb',{
        observer:true,
        observeParents:true,
        observeSlideChildren: true,
        direction,
        slidesPerView : 'auto',  
        spaceBetween : 6,
        watchSlidesVisibility: true,
        resistanceRatio:0,
        breakpointsBase: 'container',
        breakpoints: {
          750:{
            slidesPerView : 7, 
            spaceBetween : 6,
          }
        }
      })
      return this.thumbSwiper;
    }
    productDoubleColumnSwiper(){
      let that = this;
      let width = document.documentElement.clientWidth;
      let allowTouchMove = width < 1025 ? true : false;
      let thumbs = {
        swiper:this.productThumbSwiper(),
        watchSlidesVisibility: true,
        autoScrollOffset: 1
      };
      this.productSwiper = new Swiper(this,{
          observer:true,
          observeParents:true,
          observeSlideChildren: true,
          loop:false,
          slidesPerView:1,
          allowTouchMove,
          thumbs,
          resistanceRatio : 0,
           navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            750:{
              slidesPerView:2,
              spaceBetween:6,
            },
            1025:{
              slidesPerView:2
            }
          },
          on:{
            init(){
              setTimeout(()=>{that.onChangeProductThumbSwiper();that.onChangeProductColor()},200)
              if(document.documentElement.clientWidth < 1025) return;
              setTimeout(()=>{
                that.viewSize = {
                  width:this.slides[this.realIndex] && this.slides[this.realIndex].querySelector('img').width,
                  height: this.slides[this.realIndex] && this.slides[this.realIndex].querySelector('img').height
                }
                that.querySelectorAll('.swiper-wrapper .swiper-slide').forEach(item =>{
                    item.onclick = ()=>{
                      if(!item.querySelector('.hand-box') || item.classList.contains('is-scale')) return;
                      item.classList.add('is-scale')
                      that.onMouserProductImg(item)
                    }
                })
               },200)
            },
            click(event){
                if(width < 750 && width > 1024) return;
                const clickedSlide = this.clickedSlide || event.target.closest('.icon-close');
                if(clickedSlide && width >= 750 && width <= 1024){
                  // if(clickedSlide.querySelector('deferred-media')) return;
                  // this.params.slidesPerView === 1 ? that.querySelector('.icon-close').classList.add('hidden') : that.querySelector('.icon-close').classList.remove('hidden')
                  // that.setAttribute('flag',this.params.slidesPerView === 1 ? 'false' : 'true')
                  // this.params.slidesPerView = this.params.slidesPerView === 1 ? 2 : 1;
                  // this.update();
                  // this.slideTo(this.clickedIndex,0,false)
                }
            },
            setTransition(){
              if(document.documentElement.clientWidth >= 1025) return;
              setTimeout(()=>{
                document.querySelectorAll('product-thumb .swiper-slide')[this.realIndex].classList.add('swiper-slide-thumb-active')
                document.querySelectorAll('product-thumb .swiper-slide')[this.previousIndex].classList.remove('swiper-slide-thumb-active')
              },200)
            }
          }
        })
    }
    onChangeProductColor(){
      if(!this.dataset.fit) return;
      document.querySelectorAll('.color__swatch').forEach(item=>{
        let color = item.getAttribute('title');
        if(!this.swiperSlideObject[this.dataset.fit][color]){ 
          item.classList.add('hidden');
        }
        else if(this.swiperSlideObject[this.dataset.fit][color] && item.classList.contains('hidden')) item.classList.remove('hidden') 
      })
    }
    observeEvent(){
      const elem = this;
      const observer = new MutationObserver((mutationsList, observer) => {
          mutationsList.forEach((item)=>{
            if(item.attributeName == 'data-color' || item.attributeName == 'data-fit'){
              new Promise((resolve, reject)=>{
                this.productSwiper.destroy();
                if(this.flag){
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });
                  this.flag = !this.flag;
                }
                if(this.dataset.fit && this.swiperSlideObject[this.dataset.fit] && !this.swiperSlideObject[this.dataset.fit][this.getAttribute('data-color')]){
                  let {color} = this.reduceData(this.variants)[this.dataset.fit][0]
                  // this.setAttribute('data-color',color);
                  document.querySelector(`.color__swatch[title="${color}"]`).click();
                  return;
                }
                
                if(this.swiperSlideObject[this.dataset.fit]){
                  document.querySelector('product-thumb .swiper-wrapper').innerHTML = this.swiperSlideObject[this.dataset.fit][this.getAttribute('data-color')]||'';
                  this.querySelector('.swiper-wrapper').innerHTML = this.swiperSlideObject[this.dataset.fit][this.getAttribute('data-color')]||'';
                }
                else{
                  document.querySelector('product-thumb .swiper-wrapper').innerHTML = this.swiperSlideObject[this.getAttribute('data-color')][this.getAttribute('data-color')]||'';
                  this.querySelector('.swiper-wrapper').innerHTML = this.swiperSlideObject[this.getAttribute('data-color')][this.getAttribute('data-color')]||'';
                }
                if(this.dataset.more == 'true') this.setAttribute('data-more','false')
                resolve()
              }).then(()=>{
                setTimeout(()=>{
                  this.productDoubleColumnSwiper();
                  if(item.attributeName == 'data-fit'){
                    this.onChangeProductColor()
                  }
                })
              })
            }
          })
      });
      observer.observe(elem, {
        attributes: true
      });
    }
    
}
customElements.define('product-double-column', productDoubleColumn);